import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from '../pages/home/Home';
import Detail from '../pages/detail/Detail';
import Scene from '../pages/scene/Scene';
import SceneNew from '../pages/scene/SceneNew';
import About from '../pages/about/About';

const AppRouter: React.FC = () => {
    
    return (
        <div className='app'>
            <Router>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/scene" element={<Scene />} />
                    <Route path="/home" element={<Home />} />
                    <Route path="/detail" element={<Detail />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/sceneNew" element={<SceneNew />} />
                </Routes>
            </Router>
        </div>
    );
}

export default AppRouter;
